import React, {useContext, useEffect, useRef, useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import Api from "../../Api";
import PayoutsDetailTags from "../PayoutsDetailTags";
import Button from "../Utils/UI/Button";
import {InputHelper} from "../Utils/FieldsHelper";
import classes from "./styles.module.css";
import MessageContext from "../../MessageContext";

function PayoutsDetailEditing({token, name, tags, suggestionsTags, registryId}) {
    const intl = useIntl();
    const {onMessage} = useContext(MessageContext);


    const [form, setForm] = useState({
        name: name || "",
        tags: tags || [],
    });

    const [isRequest, setIsRequest] = useState(false);

    // храним предыдущие пропсы, чтобы видеть, реально ли что-то поменялось
    const prevPropsRef = useRef({name, tags});

    useEffect(() => {
        const prev = prevPropsRef.current;
        const nextName = name || "";
        const nextTags = tags || [];

        const nameChanged = prev.name !== nextName;
        const tagsChanged = prev.tags !== nextTags;


        // обновляем форму ТОЛЬКО если реально поменялись входные пропсы
        if (nameChanged || tagsChanged) {
            setForm((prevForm) => {

                return {
                    ...prevForm,
                    name: nextName,
                    tags: nextTags,
                };
            });

            prevPropsRef.current = {name: nextName, tags: nextTags};
        }
    }, [name, tags]);

    function onChangeName(field, value) {


        setForm((prev) => {
            if (prev[field] === value) {
                return prev;
            }

            const next = {...prev, [field]: value};
            return next;
        });
    }

    function onSelectedTag(nextTags) {

        setForm((prev) => {
            // простая проверка, изменился ли состав тегов
            const prevTags = prev.tags || [];
            const sameLength = prevTags.length === nextTags.length;
            const sameItems =
                sameLength &&
                prevTags.every((t, i) => t === nextTags[i]);

            if (sameItems) {
                return prev;
            }

            const out = {...prev, tags: nextTags};
            return out;
        });
    }

    function save() {

        if (!form.name.trim()) {
            onMessage({
                type: "error",
                message: intl.formatMessage({id: "PayoutsDetailEditing.error.emptyName"}),
            });
            return;
        }

        setIsRequest(true);

        new Api({token})
            .updateRegistryData(registryId, form)
            .then((r) => {

                if (r && r.error) {
                    onMessage({
                        type: "error",
                        message: intl.formatMessage({id: "PayoutsDetailEditing.error.generic"}),
                    });
                } else if (r && r.code) {
                    onMessage({
                        type: "error",
                        message: `code ${r.code}: ${r.message}`,
                    });
                } else {
                    onMessage({
                        type: "success",
                        message: intl.formatMessage({id: "PayoutsDetailEditing.success.saved"}),
                    });
                }
            })
            .catch((e) => {
                onMessage({
                    type: "error",
                    message: intl.formatMessage({id: "PayoutsDetailEditing.error.network"}),
                });
            })
            .finally(() => {
                setIsRequest(false);
            });
    }


    return (
        <div className={classes.Card}>
            <div className={classes.Body}>
                <div className={classes.Group}>
                    <h6 className={classes.Title}>
                        <FormattedMessage
                            id="PayoutsDetailEditing.title"
                            defaultMessage="Редактирование реестра"
                        />
                    </h6>

                    <div className={classes.Input}>
                        <InputHelper
                            onChange={onChangeName}
                            value={form.name}
                            placeholder={intl.formatMessage({
                                id: "PayoutsDetailEditing.placeholder.name",
                            })}
                            fieldName="name"
                            label="FieldsHelper.label.registryName"
                            changeRegexp={/[^А-Яа-яA-Za-z0-9_().\s]+/g}
                            blurRegexp={/[А-Яа-яA-Za-z0-9_().]+/gi}
                            changeMessage="FieldsHelper.error.onlyCyrLatinRegisterName"
                            blurMessage="FieldsHelper.error.checkRegisterName"
                            isDisabled={isRequest}
                        />
                    </div>

                    <div className={classes.Input}>
                        <h5>
                            <FormattedMessage
                                id="PayoutsDetailEditing.label.tags"
                                defaultMessage="Метки"
                            />
                        </h5>
                        <PayoutsDetailTags
                            tags={form.tags}
                            suggestionsTags={suggestionsTags}
                            onSelectedTag={onSelectedTag}
                        />
                    </div>
                </div>
            </div>

            <div className={classes.Footer}>
                <Button
                    onClick={save}
                    label="PayoutsDetailEditing.btn.save"
                    color="#35C98E"
                    icon="floppy-o"
                    isLoading={isRequest}
                />
            </div>
        </div>
    );
}

export default PayoutsDetailEditing;



// WEBPACK FOOTER //
// ./src/Components/PayoutsDetailEditing/index.js